import React, { useContext } from 'react'
import firebase from "../../firebase/index"
import SITEINFO from "../../constants/siteInfo"
import { makeStyles } from '@material-ui/core/styles'
import { NavLink, useLocation } from 'react-router-dom'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core'
import {
  Mail as MailIcon,
  Info as InfoIcon,
  QuestionAnswer as QuestionAnswerIcon,
  PostAdd as PostAddIcon,
  WebAsset as WebAssetIcon,
  SupervisedUserCircle as SupervisedUserCircleIcon,
  Business as BusinessIcon,
  Group as GroupIcon,
  Face as FaceIcon,
  Feedback as FeedbackIcon,
  Person as PersonIcon,
  ExitToApp as ExitToAppIcon,
  Settings as SettingsIcon,
  ContactSupport as ContactSupportIcon
} from '@material-ui/icons'
import { GlobalContext } from '../../hooks/reducer'
import { commonTheme } from '../../materialui/theme'
import ListItemContent from './SidebarListItem'

const getStyles = makeStyles((theme) => ({
  sidebar: {

  },
  toolbar: {
    ...theme.mixins.toolbar,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingTop: '25px'
  },
  link: {
    textDecoration: 'none',
  },
  button: {
    borderTop: `1px solid ${commonTheme.palette.primary.light}`,
    padding: '10px 16px'
  },
  nowButtonText: {
    // backgroundColor: '#354c69',
    // '&:hover': {
    //   backgroundColor: '#354c6994',
    // }
    '& > span': {
      color: commonTheme.palette.secondary.main,
    },
  },
  text: {
    '& > span': {
      color: commonTheme.palette.primary.light,
      fontWeight: 400
    }
  },
  caseText: {
    // color: commonTheme.palette.secondary.main,
  },
  // icon: {
  //   color: commonTheme.palette.primary.light,
  // }
}))

const Sidebar = React.memo((props) => {
  const { state: { loginUser }, dispatch } = useContext(GlobalContext)
  const { user } = loginUser
  const location = useLocation()
  const classes = getStyles()

  // サイドバー項目
  const sidebarItems = [
    {
      link: 'info',
      name: 'お知らせ',
      secondary: null,
      icon: <InfoIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: '',
      name: 'みんなの事例共有',
      secondary: '他社の事例共有が見られます',
      icon: <PostAddIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: `company/${user.companyId}`,
      name: 'わたしの事例共有',
      secondary: 'あなたの会社の事例共有一覧です',
      icon: <BusinessIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: `fb/${user.companyId}`,
      name: 'フィードバック',
      secondary: null,
      icon: <FeedbackIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'consult',
      name: '相談部屋',
      secondary: null,
      icon: <QuestionAnswerIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'about_site',
      name: 'サイト概要',
      secondary: null,
      icon: <WebAssetIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'about_instructors',
      name: '講師紹介',
      secondary: null,
      icon: <SupervisedUserCircleIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'my_account',
      name: 'マイページ',
      secondary: null,
      icon: <PersonIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'my_account/notice',
      name: '通知設定',
      secondary: null,
      icon: <SettingsIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'member',
      name: 'メンバー管理',
      secondary: null,
      icon: <GroupIcon />,
      adminOnly: true,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      fulllink: 'https://opaque-pyjama-909.notion.site/CCS-2090d26dcb5c807982c2d05b2f4e16af',
      name: 'サポートページ',
      secondary: '困った時はこちら',
      icon: <ContactSupportIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'contact',
      name: 'お問い合わせ',
      secondary: null,
      icon: <MailIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'admin',
      name: `${SITEINFO.adminName}管理ページ`,
      secondary: null,
      icon: <FaceIcon />,
      adminOnly: true,
      devOnly: false,
      pajapossOnly: true,
    },
    {
      link: 'admin/import-users',
      name: `一括登録`,
      secondary: null,
      icon: <FaceIcon />,
      nozomi: true,
    },
    {
      link: 'login',
      name: 'ログアウト',
      secondary: null,
      icon: <ExitToAppIcon />,
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
    {
      link: 'signup',
      name: `会員登録\n（会社代表）`,
      secondary: '登録される方にこちらのURLをお送りください',
      icon: '',
      adminOnly: false,
      devOnly: false,
      pajapossOnly: true,
    },
    {
      link: '',
      name: '',
      secondary: null,
      icon: '',
      adminOnly: false,
      devOnly: false,
      pajapossOnly: false,
    },
  ]

  const handleSignOut = () => {
    firebase.auth().signOut().then(() => {
      console.log("ログアウト")
      dispatch({ type: 'RESET' })
    }).catch((error) => {
      console.log("error", error)
    })
  }

  return (
    <div className={classes.sidebar}>

      <Typography variant='body1' component='h1' color='secondary' className={classes.toolbar}>{SITEINFO.title}</Typography>

      <List>
        {sidebarItems.map((sidebarItem, key) => {
          if (sidebarItem.nozomi) { 
            if (user.email !== "acid.hina.nn@gmail.com") return '' 
          }

          // 開発環境のみ
          if (sidebarItem.devOnly) { if (process.env.NODE_ENV !== 'development') return '' }

          // 管理者権限のみ
          if (sidebarItem.adminOnly) { if (!user.admin) return '' }

          // パジャポスメンバーのみ
          if (sidebarItem.pajapossOnly) { if (!user.pajaposs) return '' }

          const isCase = sidebarItem.link === ''
          const path = sidebarItem.link ? `/${sidebarItem.link}` : '/'
          const isActive = location.pathname === path

          // 直接リンク
          if (sidebarItem.fulllink) {
            return <NavLink
              key={key}
              exact
              to={{ pathname: sidebarItem.fulllink }}
              onClick={null}
              className={classes.link}
              target="_blank"
              rel="noopener noreferrer"
              activeStyle={classes.current}
              isActive={() => false}
            >
              <ListItemContent
                item={sidebarItem}
                classes={classes}
                isActive={false}   
                isCase={isCase}
              />
            </NavLink>
          }

          return <NavLink
            key={key}
            exact
            to={path}
            onClick={(sidebarItem.link === 'login') ? () => handleSignOut() : null}
            className={classes.link}
            activeStyle={classes.current}
          >
            <ListItemContent
              item={sidebarItem}
              classes={classes}
              isActive={isActive}
              isCase={isCase}
            />
          </NavLink>
        })}
      </List>
    </div>
  )
})

export default Sidebar
